import { Button, createStyles, Grid, makeStyles, MenuItem, TextField, Theme } from '@material-ui/core';
import sicrediStyles from 'assets/styles/default.scss';
import { InvertedChevronIcon, SyncIcon } from 'components/Icons';
import { AssembleiaStatus } from 'enuns/AssembleiaStatus';
import React, { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { assembleiasAssessorActionsAlterarSituacaoAssembleia, assembleiasAssessorLoadEvento } from 'store/modules/AssembleiasAssessorActions';
import { modalsActionsClose } from 'store/modules/ModalsActions';
import { getToastError } from 'utils/ToasterUtils';
import { IModalProps } from '../../store/modules/ModalsReducer';
import { IReducer } from '../../store/Reducer';
import GenericModal, { IGenericModalProps } from '../GenericModal/GenericModal';

export interface IAssembleiaAlterarSituacaoModalGenericProps extends IGenericModalProps {
  key: string
}

export interface IAssembleiaAlterarSituacaoModal extends IModalProps {
  genericProps?: IAssembleiaAlterarSituacaoModalGenericProps,
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    selectRoot: {
      marginTop: '10px',
      width: '100% !important'
    },
    dropdownIcon: {
      fontSize: 16,
      color: sicrediStyles.primarySicredi,
      position: 'absolute',
      right: 0,
      top: '50%',
      transform: 'translateY(-50%)'
    },
    actionsContent: {
      display: 'flex',
      justifyContent: 'flex-end'
    }
  }),
);

const INITIAL_STATUS = -1;

export default ({ genericProps }: IAssembleiaAlterarSituacaoModal) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const [status, setStatus] = useState<AssembleiaStatus>(INITIAL_STATUS);
  const [salvando, setSalvando] = useState<boolean>(false);
  const assembleiasAssessor = useSelector((state: IReducer) => state.assembleiasAssessor);
  const reduxDispatch = useDispatch();

  const toClose = useCallback((): void => {
    if (genericProps && genericProps.key) {
      reduxDispatch(modalsActionsClose(genericProps.key));
    }
  }, [reduxDispatch, genericProps])

  const handleStatus = (event: React.ChangeEvent<{ value: unknown }>) => {
    setStatus(event.target.value as AssembleiaStatus);
  }

  const confirmado = useCallback(() => {
    reduxDispatch(assembleiasAssessorLoadEvento(assembleiasAssessor.evento!.id));
    toClose()
  }, [reduxDispatch, assembleiasAssessor.evento, toClose])

  const confirmar = () => {
    if (status > -1) {
      setSalvando(true);
      reduxDispatch(assembleiasAssessorActionsAlterarSituacaoAssembleia(
        assembleiasAssessor.evento!.id,
        status,
        () => confirmado(),
        (error) => {
          const message: string = error.response && error.response.data && error.response.data.message ? error.response.data.message : error.message;
          getToastError(message);
          setSalvando(false)
        },
      ));
    }
  }

  const confirmarDisabled = useCallback((): boolean => {
    if (salvando || status === assembleiasAssessor.evento!.status) {
      return true;
    }
    return false;
  }, [status, assembleiasAssessor.evento, salvando])

  useEffect(() => {
    if (status === INITIAL_STATUS) {
      setStatus(assembleiasAssessor.evento!.status);
    }
  }, [status, assembleiasAssessor.evento]);

  return (
    <GenericModal
      title={ t("AssembleiaAlterarSituacaoModal.title") }
      content={(
        <Grid
          container spacing={3}
        >
          <Grid item xs={ 12 }>
            <TextField
              value={ status }
              onChange={ event => handleStatus(event) }
              className={classes.selectRoot}
              SelectProps={{
                IconComponent: () => (
                  <InvertedChevronIcon className={classes.dropdownIcon} />
                ),
              }}
              select
            >
              {
                [
                  AssembleiaStatus.NaoDisponivel,
                  // AssembleiaStatus.Pre,
                  AssembleiaStatus.Live,
                  // AssembleiaStatus.Pos,
                  AssembleiaStatus.Encerrado,
                ].map((status: AssembleiaStatus, key: number): React.ReactNode => {
                  return <MenuItem value={status} key={ key }>{ t('AssembleiaStatus.' + status) }</MenuItem>
                })
              }
            </TextField>
          </Grid>
          <Grid item xs={ 12 } className={ classes.actionsContent }>
            <Button
              variant="contained"
              color="primary"
              onClick={ confirmar }
              disabled={ confirmarDisabled() }
              endIcon={ salvando ? <SyncIcon className="animation-rotate" /> : null }
            >
              { t("AssembleiaAlterarSituacaoModal.confirmarButton") }
            </Button>
          </Grid>
        </Grid>
      )}
      genericProps={{
        maxWidth: 'sm',
        onClose: !salvando ? toClose : undefined,
      }}
      />
  )
}